/* ============================================================
   BEST LOGO MATS™ — AI Mat Assistant
   Powered by Claude | bestlogomats.com | 321.751.4636
   ============================================================ */

(function() {

/* ── System prompt — deeply trained on BLM knowledge ── */
var BLM_SYSTEM = `You are the Best Logo Mats™ AI Mat Assistant — an expert on custom logo floor mats. You represent Best Logo Mats™, a division of BoatMat Corporation™, located at 245 SW 31st Street, Fort Lauderdale, FL 33315. Phone: 321.751.4636. Email: info@bestlogomats.com. In business since 1995. CEO: Patrick A. Durso.

CRITICAL: You are the MANUFACTURER — not a reseller. Always emphasize this. Every mat is handcrafted at our HQ in Fort Lauderdale FL and our partner plant in Georgia.

PRODUCT LINE:
- CrystalPrint HD™: Indoor. HD digital print on PET fiber carpet. 150 colors. $245–$940+. Best seller.
- AquaShield Elite™: Outdoor. Precision inlaid — colors permanently embedded, never fade. $249–$1,549+. Outdoor king.
- AquaShield HD™: Indoor/wet entries. WaterHog-style waffle surface with HD print. $339–$940+.
- StormGuard Pro™: Outdoor all-rubber. 150 colors, UV-resistant. $214–$784+. Best outdoor value.
- EcoVivid™: Indoor. 100% recycled PET. 60 colors. $192–$940+. Eco choice.
- BerberHD™: Indoor/covered outdoor. Classic berber + HD print. 80% recycled PET. $159–$940+.
- ComfortPrint™: Anti-fatigue. Cushioned standing mat with branding. 150 colors. $258–$475+.
- QuickBrand™: Event/POP/trade show. Portable rubber mat. 150 colors. From $85.
- SwiftScrape™: Outdoor short-term rubber scraper. From $84.
- ImpactFloor™: Indoor POP display. Full-color rubber. From $149.

STANDARD SIZES: 2x3, 3x5, 4x6, 4x8, 5x8, 6x10 ft. Custom sizes available.

KEY FACTS — memorize and use:
- $0 setup fees — ALWAYS. No exceptions.
- 1 mat minimum — no minimum order ever.
- Free design proof in 24 hours — even if they have no logo file.
- Free ground shipping on all orders in the lower 48 — all 48 contiguous US states.
- 5 business day production from proof approval.
- 100% satisfaction guaranteed.
- 250,000+ happy clients.
- 4.9 stars / 2,847 reviews.
- Free unlimited revisions on design proof.
- No charge until customer approves proof.
- Rush production available — call 321.751.4636.
- Accepted art files: AI, EPS, PDF (vector preferred), PNG, JPG, SVG.
- We beat ALL competitor prices by at least 3%.

COMPETITORS (use to differentiate, never disparage):
- Rugtomize: reseller, we are the actual manufacturer.
- PersonalizedDoormats.com: reseller, our prices are lower.
- AmericanFloorMats.com: distributor, not manufacturer.
- MyLogoMat.com: reseller, slower production.
- UltimateMats.com: reseller, we manufacture direct.
- LogoMatCentral.com: reseller, we have no middlemen.

HOW TO HELP CUSTOMERS:
1. Ask what the mat is for (lobby, outdoor entrance, trade show, anti-fatigue, etc.)
2. Ask about their size needs
3. Ask if they have artwork or need free design
4. Recommend the right product from the line above
5. Always invite them to call 321.751.4636 or scroll up to the order form

TONE: Friendly, expert, confident, direct. You know mats better than anyone. Short punchy answers. Use bullet points for product specs. Always end with a clear next step.

NEVER: Make up prices beyond what's listed. Claim competitors are bad — just state your advantages. Give false delivery promises.`;

/* ── Chat UI HTML ── */
var chatHTML = `
<div id="blm-chat-widget" class="blm-chat-widget">

  <!-- Launcher button -->
  <button class="blm-chat-launcher" id="blm-chat-launcher" aria-label="Open Mat Assistant">
    <span class="blm-chat-launcher-icon">🤖</span>
    <span class="blm-chat-launcher-text">Mat Assistant</span>
    <span class="blm-chat-notify" id="blm-chat-notify">1</span>
  </button>

  <!-- Chat window -->
  <div class="blm-chat-window" id="blm-chat-window" style="display:none">
    <div class="blm-chat-header">
      <div class="blm-chat-header-left">
        <div class="blm-chat-avatar">🤖</div>
        <div>
          <div class="blm-chat-title">Mat Assistant</div>
          <div class="blm-chat-subtitle">Best Logo Mats™ · Typically replies instantly</div>
        </div>
      </div>
      <div class="blm-chat-header-right">
        <a href="tel:+13217514636" class="blm-chat-call" title="Call us">📞</a>
        <button class="blm-chat-close" id="blm-chat-close" aria-label="Close">✕</button>
      </div>
    </div>

    <div class="blm-chat-messages" id="blm-chat-messages">
      <div class="blm-msg blm-msg-bot">
        <div class="blm-msg-bubble">
          👋 Hey! I'm the Best Logo Mats™ AI assistant.<br><br>
          I can help you pick the right mat, explain the difference between products, answer pricing questions, or walk you through ordering.<br><br>
          What can I help you with today?
        </div>
      </div>
      <div class="blm-chat-suggestions" id="blm-chat-suggestions">
        <button class="blm-suggest" onclick="blmSuggest('What mat is best for an outdoor entrance?')">Outdoor entrance mat</button>
        <button class="blm-suggest" onclick="blmSuggest('How much does a custom logo mat cost?')">Pricing</button>
        <button class="blm-suggest" onclick="blmSuggest('I need a mat for a trade show or event')">Event / trade show</button>
        <button class="blm-suggest" onclick="blmSuggest('What is the difference between your mat types?')">Compare products</button>
      </div>
    </div>

    <div class="blm-chat-input-wrap">
      <input type="text" id="blm-chat-input" class="blm-chat-input"
             placeholder="Ask me anything about logo mats..."
             autocomplete="off" maxlength="500">
      <button class="blm-chat-send" id="blm-chat-send" aria-label="Send">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg>
      </button>
    </div>

    <div class="blm-chat-footer">
      Powered by AI · <a href="tel:+13217514636">Call 321.751.4636</a> for immediate help
    </div>
  </div>

</div>`;

/* ── CSS ── */
var chatCSS = `
#blm-chat-widget{position:fixed;bottom:24px;right:24px;z-index:9999;font-family:'Plus Jakarta Sans','Inter',sans-serif}

.blm-chat-launcher{
  display:flex;align-items:center;gap:8px;
  background:#0d2461;color:#fff;border:none;border-radius:50px;
  padding:12px 20px;font-size:.88rem;font-weight:700;cursor:pointer;
  box-shadow:0 4px 20px rgba(13,36,97,.4);transition:all .2s;
  position:relative;letter-spacing:.01em;
}
.blm-chat-launcher:hover{background:#142e7a;transform:translateY(-2px);box-shadow:0 8px 28px rgba(13,36,97,.5)}
.blm-chat-launcher-icon{font-size:1.1rem}
.blm-chat-notify{
  position:absolute;top:-6px;right:-6px;background:#dc2626;color:#fff;
  font-size:.62rem;font-weight:800;width:18px;height:18px;border-radius:50%;
  display:flex;align-items:center;justify-content:center;animation:blm-pulse 2s infinite;
}
@keyframes blm-pulse{0%,100%{transform:scale(1)}50%{transform:scale(1.15)}}

.blm-chat-window{
  position:absolute;bottom:60px;right:0;
  width:360px;max-height:520px;
  background:#fff;border-radius:16px;
  box-shadow:0 20px 60px rgba(0,0,0,.18),0 4px 20px rgba(13,36,97,.1);
  display:flex;flex-direction:column;overflow:hidden;
  border:1px solid rgba(13,36,97,.1);
  animation:blm-slide-up .2s ease;
}
@keyframes blm-slide-up{from{opacity:0;transform:translateY(12px)}to{opacity:1;transform:none}}
@media(max-width:480px){
  .blm-chat-window{width:calc(100vw - 32px);right:-16px;bottom:64px;max-height:70vh}
  #blm-chat-widget{bottom:16px;right:16px}
}

.blm-chat-header{
  background:#0d2461;color:#fff;padding:14px 16px;
  display:flex;align-items:center;justify-content:space-between;flex-shrink:0;
}
.blm-chat-header-left{display:flex;align-items:center;gap:10px}
.blm-chat-avatar{font-size:1.6rem;background:rgba(255,255,255,.15);width:38px;height:38px;border-radius:50%;display:flex;align-items:center;justify-content:center}
.blm-chat-title{font-size:.92rem;font-weight:700;letter-spacing:.01em}
.blm-chat-subtitle{font-size:.66rem;color:rgba(255,255,255,.55);margin-top:1px}
.blm-chat-header-right{display:flex;align-items:center;gap:8px}
.blm-chat-call{color:rgba(255,255,255,.7);font-size:1.1rem;text-decoration:none;transition:color .15s;padding:2px}
.blm-chat-call:hover{color:#fff}
.blm-chat-close{background:rgba(255,255,255,.15);border:none;color:#fff;width:28px;height:28px;border-radius:50%;cursor:pointer;font-size:.85rem;display:flex;align-items:center;justify-content:center;transition:all .15s}
.blm-chat-close:hover{background:rgba(255,255,255,.3)}

.blm-chat-messages{
  flex:1;overflow-y:auto;padding:14px;display:flex;flex-direction:column;gap:10px;
  background:#f8fafc;scroll-behavior:smooth;
}
.blm-chat-messages::-webkit-scrollbar{width:4px}
.blm-chat-messages::-webkit-scrollbar-track{background:transparent}
.blm-chat-messages::-webkit-scrollbar-thumb{background:#dde6f0;border-radius:2px}

.blm-msg{display:flex;flex-direction:column;max-width:85%}
.blm-msg-bot{align-self:flex-start}
.blm-msg-user{align-self:flex-end}
.blm-msg-bubble{
  padding:10px 13px;border-radius:12px;font-size:.83rem;line-height:1.55;
}
.blm-msg-bot .blm-msg-bubble{background:#fff;color:#1a1a2e;border:1px solid #dde6f0;border-radius:12px 12px 12px 3px;box-shadow:0 1px 4px rgba(0,0,0,.06)}
.blm-msg-user .blm-msg-bubble{background:#0d2461;color:#fff;border-radius:12px 12px 3px 12px}

.blm-msg-typing .blm-msg-bubble{padding:12px 16px}
.blm-typing-dots{display:flex;gap:4px;align-items:center}
.blm-typing-dots span{width:7px;height:7px;background:#94a3b8;border-radius:50%;animation:blm-bounce .9s infinite}
.blm-typing-dots span:nth-child(2){animation-delay:.2s}
.blm-typing-dots span:nth-child(3){animation-delay:.4s}
@keyframes blm-bounce{0%,60%,100%{transform:translateY(0)}30%{transform:translateY(-6px)}}

.blm-chat-suggestions{display:flex;flex-wrap:wrap;gap:6px;margin-top:2px}
.blm-suggest{
  background:#fff;border:1.5px solid #dde6f0;border-radius:20px;
  padding:5px 12px;font-size:.73rem;font-weight:600;color:#0d2461;
  cursor:pointer;transition:all .15s;font-family:inherit;
}
.blm-suggest:hover{background:#0d2461;color:#fff;border-color:#0d2461}

.blm-chat-input-wrap{
  padding:10px 12px;border-top:1px solid #e2e8f0;background:#fff;
  display:flex;gap:8px;align-items:center;flex-shrink:0;
}
.blm-chat-input{
  flex:1;border:1.5px solid #dde6f0;border-radius:22px;padding:9px 14px;
  font-size:.84rem;font-family:inherit;color:#1a1a2e;background:#f8fafc;
  transition:border-color .15s;outline:none;
}
.blm-chat-input:focus{border-color:#0d2461;background:#fff}
.blm-chat-input::placeholder{color:#94a3b8}
.blm-chat-send{
  width:36px;height:36px;border-radius:50%;background:#0d2461;
  border:none;color:#fff;cursor:pointer;transition:all .15s;
  display:flex;align-items:center;justify-content:center;flex-shrink:0;
}
.blm-chat-send:hover{background:#142e7a;transform:scale(1.08)}
.blm-chat-send:disabled{opacity:.45;cursor:not-allowed;transform:none}

.blm-chat-footer{
  padding:7px 12px;text-align:center;font-size:.8rem;color:#94a3b8;
  background:#f8fafc;border-top:1px solid #e2e8f0;flex-shrink:0;
}
.blm-chat-footer a{color:#0d2461;font-weight:600;text-decoration:none}
.blm-chat-footer a:hover{text-decoration:underline}
`;

/* ── Inject CSS ── */
var style = document.createElement('style');
style.textContent = chatCSS;
document.head.appendChild(style);

/* ── Inject HTML ── */
var div = document.createElement('div');
div.innerHTML = chatHTML;
document.body.appendChild(div.firstElementChild);

/* ── State ── */
var isOpen      = false;
var isTyping    = false;
var chatHistory = [];

/* ── Elements ── */
function el(id){ return document.getElementById(id) }

/* ── Open / Close ── */
el('blm-chat-launcher').addEventListener('click', function(){
  isOpen = !isOpen;
  el('blm-chat-window').style.display = isOpen ? 'flex' : 'none';
  if(isOpen){
    el('blm-chat-notify').style.display = 'none';
    el('blm-chat-input').focus();
  }
});
el('blm-chat-close').addEventListener('click', function(){
  isOpen = false;
  el('blm-chat-window').style.display = 'none';
});

/* ── Send message ── */
function blmSend(text){
  text = (text || el('blm-chat-input').value).trim();
  if(!text || isTyping) return;

  // Hide suggestions
  var sugg = el('blm-chat-suggestions');
  if(sugg) sugg.style.display = 'none';

  // Add user message
  addMsg(text, 'user');
  el('blm-chat-input').value = '';
  chatHistory.push({ role:'user', content: text });

  // Show typing
  isTyping = true;
  el('blm-chat-send').disabled = true;
  var typingEl = addTyping();

  // Call Anthropic API
  fetch('https://api.anthropic.com/v1/messages', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      model: 'claude-sonnet-4-20250514',
      max_tokens: 512,
      system: BLM_SYSTEM,
      messages: chatHistory
    })
  })
  .then(function(r){ return r.json() })
  .then(function(data){
    typingEl.remove();
    var reply = (data.content && data.content[0] && data.content[0].text) || "I'm having a moment — please call us at 321.751.4636 and we'll help right away!";
    chatHistory.push({ role:'assistant', content: reply });
    addMsg(reply, 'bot');
  })
  .catch(function(){
    typingEl.remove();
    addMsg("Sorry, I'm having a hiccup. Call us at 📞 <a href='tel:+13217514636' style='color:#0d2461;font-weight:700'>321.751.4636</a> and we'll help you immediately!", 'bot', true);
  })
  .finally(function(){
    isTyping = false;
    el('blm-chat-send').disabled = false;
    el('blm-chat-input').focus();
  });
}

function blmSuggest(text){
  el('blm-chat-input').value = text;
  blmSend(text);
}

function addMsg(text, role, isHTML){
  var msgs = el('blm-chat-messages');
  var msg  = document.createElement('div');
  msg.className = 'blm-msg blm-msg-' + role;
  var bubble = document.createElement('div');
  bubble.className = 'blm-msg-bubble';
  if(isHTML) bubble.innerHTML = text;
  else {
    // Convert markdown-lite: **bold**, newlines, links
    var safe = text
      .replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;')
      .replace(/\*\*(.*?)\*\*/g,'<strong>$1</strong>')
      .replace(/\*(.*?)\*/g,'<em>$1</em>')
      .replace(/\n/g,'<br>');
    bubble.innerHTML = safe;
  }
  msg.appendChild(bubble);
  msgs.appendChild(msg);
  msgs.scrollTop = msgs.scrollHeight;
  return msg;
}

function addTyping(){
  var msgs = el('blm-chat-messages');
  var msg  = document.createElement('div');
  msg.className = 'blm-msg blm-msg-bot blm-msg-typing';
  msg.innerHTML = '<div class="blm-msg-bubble"><div class="blm-typing-dots"><span></span><span></span><span></span></div></div>';
  msgs.appendChild(msg);
  msgs.scrollTop = msgs.scrollHeight;
  return msg;
}

/* ── Keyboard send ── */
el('blm-chat-input').addEventListener('keydown', function(e){
  if(e.key === 'Enter' && !e.shiftKey){ e.preventDefault(); blmSend(); }
});
el('blm-chat-send').addEventListener('click', function(){ blmSend(); });

/* ── Expose for inline onclick ── */
window.blmSuggest = blmSuggest;
window.blmSend    = blmSend;

/* ── Auto open with greeting after 8s if not opened ── */
setTimeout(function(){
  if(!isOpen){
    el('blm-chat-notify').textContent = '1';
    el('blm-chat-notify').style.display = 'flex';
  }
}, 8000);

})();
